import {
  Button,
  Stack,
} from "@mui/material";

import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";

export default function ReportActions({
  onRefresh,
  onPrint,
  onPdf,
  onExcel,
}) {
  return (
   <Stack
  direction="row"
  spacing={1}
  sx={{
    flexWrap: "wrap",
  }}
>
      <Button
        startIcon={<RefreshIcon />}
        onClick={onRefresh}
      >
        Refresh
      </Button>

      <Button
        startIcon={<PrintIcon />}
        onClick={onPrint}
      >
        Print
      </Button>

      <Button
        variant="contained"
        color="error"
        startIcon={<PictureAsPdfIcon />}
        onClick={onPdf}
      >
        PDF
      </Button>

      {/* <Button
        variant="contained"
        color="success"
        startIcon={<TableChartIcon />}
        onClick={onExcel}
      >
        Excel
      </Button> */}
    </Stack>
  );
}